import React from 'react'
import { Box, Typography } from '@mui/material'
import { motion } from 'framer-motion'

export default function EventTimer({ seconds, large = false }) {
  const urgent = seconds <= 5
  const color = urgent ? '#ef5350' : seconds <= 10 ? '#ffa726' : '#42a5f5'

  return (
    <motion.div
      animate={urgent ? { scale: [1, 1.1, 1] } : {}}
      transition={{ repeat: urgent ? Infinity : 0, duration: 0.5 }}
    >
      <Box sx={{
        width: large ? 120 : 80,
        height: large ? 120 : 80,
        borderRadius: '50%',
        border: `4px solid ${color}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mx: 'auto',
        boxShadow: urgent ? `0 0 20px ${color}80` : 'none'
      }}>
        <Typography
          variant={large ? 'h2' : 'h4'}
          fontWeight="bold"
          sx={{ color }}
        >
          {seconds}
        </Typography>
      </Box>
    </motion.div>
  )
}
